import { Component } from "@angular/core";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";

@Component({
    selector: "app-about-us",
    imports: [AppLayoutComponent],
    templateUrl: "./about-us.component.html",
    styleUrl: "./about-us.component.scss"
})
export class AboutUsComponent {}
